// removed by extract-text-webpack-plugin
module.exports = {"anim_body":"slide_rec_3wfCz3h","anim_element":"slide_rec_iBef-8n","bg":"slide_rec_ex6C2q4","thumb":"slide_rec_vU-cQkh","inactive":"slide_rec_3higuaH","active":"slide_rec_23ulPKR"};


//////////////////
// WEBPACK FOOTER
// ./src/component/rec/slide_rec.css
// module id = 835
// module chunks = 0